export default __webpack_public_path__ + "8dcb7582b1fde7a0424cdf58b73a1b49.png";